module.exports = __webpack_public_path__ + "static/6-545917e0b85f840a13ae410f390beecd.png";